var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapping",class:_vm.appClass,attrs:{"id":"app"}},[_c('vue-header'),_c('router-view'),_c('vue-footer-ssi',{attrs:{"full":_vm.footerSize,"mounted":_vm.mounted}}),_c('vue-testcookie')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }